module.exports = __webpack_public_path__ + "static/Tagline-3d99500310ffc6b71440dbdba4001a20.png";